'use client';

import { Button } from 'react-aria-components';
import { CopyIcon } from './CopyIcon';
import styles from './ReusableFullWidthText.module.css';
import { useCopyToClipboard } from './useCopyToClipboard';

type InlineCodeProps = Readonly<{
  code: string;
}>;

export const InlineCode = ({ code }: InlineCodeProps) => {
  const { status, label, copy } = useCopyToClipboard();

  return (
    <Button className={styles.inlineCode} aria-label={`${label}: ${code}`} onPress={() => copy(code)}>
      <code>{code}</code>
      <CopyIcon status={status} />
    </Button>
  );
};
